import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-header-public',
  templateUrl: './header-public.component.html'
})
export class HeaderPublicComponent {

}
